import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import "./CategoriesModeVideo.scss";

import {LoadingBar} from "../../../../components/Loader";
import {Button} from "../../../../components/Button";
import {
    fetchCategoriesModeVideo,
    resetCategoriesModeVideo
} from "../../../../../creators/tagModerations.categoriesModeVideo";
import history from "../../../../../libs/history";


class CategoriesModeVideo extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }

        this.props.fetchCategoriesModeVideo({type : this.props.type});
    }

    componentWillUnmount() {
        this.props.resetCategoriesModeVideo();
    }


    render() {
        return !this.props.categoriesModeVideoInitialized ? <LoadingBar /> : (
            <div className={"categories-list"}>
                <div className={"category-title"} onClick={()=> this.props.handleDisplayCategory(this.props.displayCategory === "modevideo" ? "" : "modevideo")}>{this.props.type === "validation" ? "Validation" : "Qualification"} des vidéos</div>
                <div className={`categories ${this.props.displayCategory === "modevideo" ? "active" : ""}`}>
                    {this.props.categoriesModeVideo.filter(category => category.totalModeration > -1).map(category =>(
                            <Button
                                key={category._id}
                                className="btn-category"
                                btnStyle={"primary"}
                                size={"small"}
                                content={`${category.title} ( ${category.totalModeration || 0} medias)`}
                                onClick={() => {history.push(`${this.props.currentUrl}-video/${category._id.toString()}`)}}
                            />
                        )
                    )}
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        categoriesModeVideo: state.categoriesModeVideo.data,
        categoriesModeVideoInitialized : state.categoriesModeVideo.initialized,
        categoriesModeVideoLoading : state.categoriesModeVideo.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategoriesModeVideo,
    resetCategoriesModeVideo
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesModeVideo);